<template>
    <MainHeader :sidebar="$route.meta.layout == 'default' ? true : false" v-if="
        $route.meta.layout == 'with-header' ||
        $route.meta.layout == 'default'
    " :showNotificationBar="isShowNotificationBar" />

    <div id="time-line-main" :class="{
        'p-0 without-header':
            $route.meta.layout !== 'with-header' &&
            $route.meta.layout !== 'default',
    }">
        <div class="main-page hide-scrollbar" :class="{
            'has-sidebar': $route.meta.layout == 'default',
            'border-radius-0': $route.meta.layout == 'full',
        }">
            <div class="main-menu" v-if="$route.meta.layout == 'default'">
                <MainMenu />
            </div>
            <div class="router-outlet">
                <router-view></router-view>
            </div>

            <Notifications :managerAccessToken="managerAccessToken" @toggleNotificationBar="toggleNotificationBar" />
        </div>
    </div>

    <OverlayLoader v-show="isLoading" />
</template>

<script>
import OverlayLoader from '@/components/base/overlay/OverlayLoader.vue';
import MainHeader from '@/components/base/MainHeader';
import MainMenu from '@/components/base/MainMenu.vue';
import Notifications from './components/base/Notifications.vue';

export default {
    name: 'App',
    components: {
        OverlayLoader,
        MainHeader,
        MainMenu,
        Notifications,
    },

    data() {
        return {
            isShowNotificationBar: false,
        };
    },

    computed: {
        isLoading: {
            get() {
                return this.$store.state.isLoading;
            },
        },
        managerAccessToken: {
            get() {
                return this.$store.state.managerAccessToken;
            },
        },
    },

    mounted() {
        if (window.innerWidth <= 768) {
            document.getElementsByTagName('html')[0].style.height =
                window.visualViewport.height.toString() + 'px';
            document.getElementById('time-line-main').style.height =
                `${window.visualViewport.height}px`;
        }
    },

    methods: {
        toggleNotificationBar(isShow) {
            this.isShowNotificationBar = isShow;
        },
    },
};
</script>
